import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { Site } from "../../../../explorer/types/SpareParts";
import useGoToPage from "../../../hook/useGoToPage";
import { useClasses } from "./SearchBarSitesList.style";

type THomePageSearchBarSites = {
    sites?: Site[];
    setOpen: (open: boolean) => void
}

const SearchBarSitesList = (props: THomePageSearchBarSites) => {

    const classes = useClasses();
    //const [_, setCurrentSite] = useCurrentSite();
    const goToPage = useGoToPage();

    const handleResultClickSite = (site: Site) => {
        props.setOpen(false);
        //setCurrentSite(site);
        goToPage.spareParts.goToInstalledBase(site.customerSiteCode!);
    };

    return (
        <List sx={classes.listResults}>
            {props.sites &&
                props.sites.map((site, mapIndex) => (
                    <ListItem
                        key={"sites_key_" + mapIndex}
                        sx={classes.listItem}
                        onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            handleResultClickSite(site);
                        }}
                    >
                        <ListItemText
                            disableTypography
                            primary={
                                <Typography
                                    color="primary"
                                    variant="h6"
                                    component="p"
                                >
                                    {site.customerSiteCode} - {site.customerSiteName}
                                </Typography>
                            }
                            secondary={
                                <Typography
                                    variant="body2"
                                    component="p"
                                    sx={classes.listItemTextSecondary}
                                >
                                  {site.address} {site.address !== "" && "-"} {site.city} {site.zipCode} ({site.country})
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
        </List>)
}

export default SearchBarSitesList;